// Lib
import React from 'react';
import { Typography } from '@mui/material';

// Components
import Image from '../../../Image';
import MyRating from '../../../Rating/MyRating';

// Hooks
import useUI from '../../../../hooks/useUI';

// Styles
import { useStyles } from './ProductRatingCardStyles';

const PRODUCT_IMAGE_SIZE = 110;
const PRODUCT_IMAGE_MOBILE_SIZE = 48;

const ProductRatingCard = ({
  product,
  updateProductRating = () => {},
  notRatedProducts = [],
}) => {
  const { classes } = useStyles();
  const { isMobileMode } = useUI();
  const { image_link: image, product_description: description } = product || {};

  return (
    <div className={classes.root}>
      <Image
        alt="productImage"
        src={image}
        imageContainer={{
          desktop: [PRODUCT_IMAGE_SIZE],
          tablet: [PRODUCT_IMAGE_SIZE],
          mobile: [PRODUCT_IMAGE_MOBILE_SIZE],
        }}
      />
      <div>
        <Typography variant="h3" className={classes.description}>
          {description}
        </Typography>
        <MyRating
          updateProductRating={updateProductRating}
          withTitle={!isMobileMode}
          className={classes.rating}
          product={product}
        />
        {notRatedProducts[product.product_id] && (
          <div className={classes.accentNote}>
            {notRatedProducts[product.product_id]}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductRatingCard;
